var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightBulb = function SvgLightBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 71,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "m24.378 51.935 16.717 2.299M39.625 3l-.492 3.578m21.962 8.983-2.877 2.181m9.177 21.882-3.578-.491m-57.239-7.87-3.577-.493m14.742-18.593L15.56 9.3m5.247 36.808a18.055 18.055 0 1 1 25.3 3.479l-2.23 1.687a12.17 12.17 0 0 0-4.708 8.05l-.26 1.9a7.222 7.222 0 0 1-14.31-1.968l.26-1.9a12.2 12.2 0 0 0-2.36-9.022z"
  })));
};
export default SvgLightBulb;